import './Outdoors.css';

function Outdoors() {
    return (
        <div className="outdoorsPageContainer">Outdoors Page</div>
    );
}

export default Outdoors;
